@if ($pointOfService(); as pointOfService) {
  <div class="boels-point-of-service-card__content -top">
    <input
      class="boels-radio-button boels-point-of-service-card__radio"
      type="radio"
      [value]="true"
      [ngModel]="$isActive()"
      [name]="pointOfService.name + 'radio'"
      [id]="pointOfService.name + 'card'"
    />

    <div class="boels-point-of-service-card__header">
      <h5 data-qa="depotDisplayName">
        {{ pointOfService.displayName }}
      </h5>
      <span>{{ pointOfService.formattedDistance }}</span>
    </div>

    @if ($pointOfService().address; as address) {
      <div class="boels-point-of-service-card__address">
        <span data-qa="depotStreet"
          >{{ address.line1 }} {{ address.line2 }}</span
        >
        <span data-qa="depotTown">{{ address.town }}</span>

        @if (!pointOfService.pickupFromRentalWall) {
          @if (pointOfService.openingDay) {
            <span>
              {{ $dayOfTheWeek() }}.
              {{ pointOfService.openingDay.openingTime?.formattedHour }} -
              {{ pointOfService.openingDay.closingTime?.formattedHour }}
              @if (pointOfService.openingDay.openingTime2) {
                <span
                  >,
                  {{ pointOfService.openingDay.openingTime2.formattedHour }}
                  -
                  {{ pointOfService.openingDay.closingTime2?.formattedHour }}
                </span>
              }
            </span>
          } @else {
            <span>
              {{ $dayOfTheWeek() }}.
              {{ 'storeFinder.storeDetails.closed' | transloco }}
            </span>
          }
        }
      </div>
    }

    @if (pointOfService.hasRentalWall) {
      <div class="boels-point-of-service-card__rental-wall-indicator">
        <img
          src="assets/images/icons/shipping/rental-wall.svg"
          aria-hidden="true"
          loading="lazy"
          alt="rental-wall"
        />
        <span>{{ 'checkout.pickup.rentalWallQuote' | transloco }}</span>
      </div>
    }
  </div>

  <section
    [ngClass]="{
      '-expanded': !$isActive(),
      '-no-rental-wall': !pointOfService.hasRentalWall,
    }"
    class="boels-point-of-service-card__content -bottom -collapse-container"
    [@collapse]="!$isActive()"
    [attr.aria-expanded]="$isActive()"
  >
    <div class="boels-point-of-service-card__content -collapse-inner">
      @if (pointOfService.hasRentalWall) {
        <ng-container
          [ngTemplateOutlet]="rentalWallTemplate"
          [ngTemplateOutletContext]="{ $implicit: pointOfService }"
        ></ng-container>
      }
      <button
        boelsButton
        variant="primary-brand"
        type="submit"
        action="next"
        class="boels-point-of-service-card__continue-button"
        [alwaysShowActionIcon]="true"
        (click)="pointOfServiceSelected.emit()"
      >
        {{ 'user.continue' | transloco }}
      </button>
    </div>
  </section>
}

<ng-template
  #rentalWallTemplate
  [boelsTemplateContext]="$pointOfService()"
  let-pointOfService
>
  <div class="boels-point-of-service-card__content -rental-wall-container">
    <p>
      {{ 'checkout.pickup.collectFromRentalWallText' | transloco }}
    </p>

    <div class="form-check">
      <input
        class="boels-radio-button"
        type="radio"
        [value]="false"
        [(ngModel)]="pointOfService.pickupFromRentalWall"
        [name]="pointOfService.displayName + 'rentalWallOption'"
        [id]="pointOfService.displayName + 'branch'"
      />
      <label class="form-check-label" [for]="pointOfService.name + 'branch'">
        {{ 'checkout.pickup.collectInBranchLabel' | transloco }}
      </label>
    </div>
    <div class="form-check">
      <input
        class="boels-radio-button"
        type="radio"
        [value]="true"
        [(ngModel)]="pointOfService.pickupFromRentalWall"
        [name]="pointOfService.displayName + 'rentalWallOption'"
        [id]="pointOfService.displayName + 'rental'"
      />
      <label class="form-check-label" [for]="pointOfService.name + 'rental'">
        {{ 'checkout.pickup.collectFromRentalWallLabel' | transloco }}
        <img
          src="assets/images/icons/shipping/rental-wall.svg"
          aria-hidden="true"
          alt="{{ 'checkout.pickup.collectFromRentalWallLabel' | transloco }}"
          loading="lazy"
        />
      </label>
    </div>

    <button
      class="boels-point-of-service-card__rental-wall-btn"
      [ngClass]="{
        '-expanded': $isInnerExpanded(),
      }"
      (click)="$isInnerExpanded.set(!$isInnerExpanded())"
    >
      {{ 'checkout.pickup.rentalWallTitle' | transloco }}
      <fa-icon
        [icon]="$isInnerExpanded() ? faCaretUp : faCaretDown"
        size="xs"
      ></fa-icon>
    </button>

    <section
      class="boels-point-of-service-card__content -collapse-container -rental-wall-explanation"
      [@collapse]="!$isInnerExpanded()"
      [attr.aria-expanded]="$isInnerExpanded()"
    >
      <p>
        {{ 'checkout.pickup.rentalWallDescription.headLine' | transloco }}
      </p>
      <ol>
        <li>
          {{
            'checkout.pickup.rentalWallDescription.nodeList.item1' | transloco
          }}
        </li>
        <li>
          {{
            'checkout.pickup.rentalWallDescription.nodeList.item2' | transloco
          }}
        </li>
        <li>
          {{
            'checkout.pickup.rentalWallDescription.nodeList.item3' | transloco
          }}
        </li>
      </ol>
      <p>
        {{ 'checkout.pickup.rentalWallDescription.bottomLine' | transloco }}
      </p>
    </section>
  </div>
</ng-template>
